module.exports = __webpack_public_path__ + "img/no-message-content.a3f551e2.png";